import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  faTimes,
  faCloudUploadAlt,
  faFile,
} from "@fortawesome/free-solid-svg-icons";
function UploadFileModal({ isOpen, toggle, loadFile, handleSubmit }) {
  const { t } = useTranslation();
  const [selectedImage, setSelectedImage] = useState(null);
  const [imgURL, setImgURL] = useState("");
  const [isImageValid, setIsImageValid] = useState(false);

  return (
    <Modal isOpen={isOpen}>
      <ModalBody>
        <div className="autoriaModal">
          <h3>{t("services.copyright.form.modals.file.title")}</h3>
          <FontAwesomeIcon
            icon={faTimes}
            className="closeButton"
            size="sm"
            onClick={toggle}
          />
          <div className="modalContent">
            <div>
              {selectedImage ? (
                <>
                  <div
                    className="INEpreview"
                    style={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {selectedImage?.type?.slice(0, 5) === "image" && (
                      <img
                        alt="not fount"
                        width={280}
                        src={URL.createObjectURL(selectedImage)}
                      />
                    )}
                  </div>
                  <div className="selecteImageInfo">
                    <FontAwesomeIcon
                      icon={faFile}
                      size="2x"
                      color="#f37b33"
                      className="ImageIcon"
                    />
                    <div className="info">
                      <p>
                        {selectedImage?.name?.length > 25
                          ? `${selectedImage?.name?.slice(0, 25)}...`
                          : selectedImage?.name}
                      </p>

                      <span>
                        {String(selectedImage?.size / 1024 ** 2).slice(0, 5)} MB
                      </span>
                    </div>
                    <FontAwesomeIcon
                      icon={faTimes}
                      size={"1x"}
                      color="#9ea0a5"
                      className="ImageIcon"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        setSelectedImage(null);
                        setIsImageValid(false);
                      }}
                    />
                    {/* {selectedImage?.size / 1024 ** 2 >= 5 ? (
                      <span
                        style={{
                          position: "absolute",
                          bottom: "-25px",
                          left: "0px",
                          color: "rgb(219, 0, 0)",
                        }}
                      >
                        {t("services.copyright.form.modals.ine.size")}
                      </span>
                    ) : (
                      ""
                    )} */}
                  </div>
                </>
              ) : (
                <div className="imageDropZoneDash--Parent">
                  <input
                    type="file"
                    id="file"
                    name="file"
                    className="imageDropZoneDash"
                    onDrop={(event) => {
                      console.log(event.target.files[0]);
                      setSelectedImage(event.target.files[0]);
                    }}
                    onChange={(event) => {
                      console.log(event.target.files[0]);
                      setSelectedImage(event.target.files[0]);
                    }}
                  />

                  <FontAwesomeIcon
                    icon={faFile}
                    size="4x"
                    color="#f37b33"
                    className="ImageIcon"
                  />
                  <div className={"UploadImageLegend"}>
                    <FontAwesomeIcon icon={faCloudUploadAlt} color="#9ea0a5" />
                    <span>{t("services.copyright.form.modals.ine.drag")}</span>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="buttons">
            <button className="first" onClick={toggle}>
              {t("services.copyright.form.modals.file.close")}
            </button>
            <button
              className="second"
              onClick={() => {
                loadFile(selectedImage);
                toggle();
              }}
              disabled={selectedImage === null}
              style={selectedImage === null ? { opacity: 0.7 } : {}}
            >
              {t("services.copyright.form.modals.file.continue")}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default UploadFileModal;
